import React, {useState} from 'react';
import GlobalConst from "../../constants/GlobalConst";
import {getTeamLogoUrl} from "../../utils/SportUtils";
import useDeviceType from "../../hooks/useDeviceType";
import SportsFilterBar from "../FilterBar/components/SportsFilterBar/SportsFilterBar";
import {FormattedMessage} from "react-intl";
import PlayerNameFilter from "../FilterBar/components/PlayerNameFilter/PlayerNameFilter";

import "./FilterToggleBar.style.scss";

const FilterToggleBar = ({isFilterBarOpen, setFilterBarOpen,hideShowAll, vm}) => {
    const {isMobile} = useDeviceType();
    const [isSearchExpanded, setIsSearchExpanded] = useState(false);
    const game = vm.filteredGames.find(g => g.GameId === vm.filters.gameId);
    const gameLeague = GlobalConst.LEAGUES_BY_SPORT_ID[game?.SportId];
    const awayTeamLogoUrl = getTeamLogoUrl(gameLeague, game?.AwayTeamId, `${gameLeague}Player`, null, null);
    const homeTeamLogoUrl = getTeamLogoUrl(gameLeague, game?.HomeTeamId, `${gameLeague}Player`, null, null);

    const handleOnGameClick = (gameId) => {
        const value = gameId === vm.filters.gameId ? null : gameId;
        vm.handleFilterChange("gameId", value);
    };

    const handlePositionClick = (position)=>{
        const value = position === vm.filters.position ? null : position;
        vm.handleFilterChange("position", value);
    };

    return <div className={`filterToggleBar ${isFilterBarOpen ? "open" : "close"} ${isSearchExpanded ? "search-expanded" : ""}`}>
        <button id="filterBtn"
                aria-label="Filter"
                onClick={() => {
            setFilterBarOpen(!isFilterBarOpen)
        }}>
            <i className="fa-solid fa-sliders"/>
            <span className="filter"><FormattedMessage id={"lobbyView.filter.filter"} /></span>
            <i className={`${isFilterBarOpen ? "fa-solid fa-angle-up" : "fa-solid fa-angle-down"}`}/>
        </button>

        <SportsFilterBar vm={vm} isOpen={isFilterBarOpen}/>

        <div className="rightSide">
            <PlayerNameFilter vm={vm} onExpandChange={setIsSearchExpanded} />
        </div>

        {vm.filters.gameId && game && !isFilterBarOpen && <button className={`gameFilter active`}
                                                                  onClick={()=> handleOnGameClick(game.GameId)}>
            <div className="teamInfo">
                <div className={"homeTeam"}>
                    <div className="homeTeamContent">
                        <span className="homeTeamLogo"
                              style={{backgroundImage: `url(${homeTeamLogoUrl})`}}/>
                        {!isMobile && <span className={"teamKey"}>{game.HomeTeamKey}</span>}
                    </div>
                </div>
                vs
                <div className={"awayTeam"}>
                    <div className='awayTeamContent'>
                        <span className="awayTeamLogo"
                              style={{backgroundImage: `url(${awayTeamLogoUrl})`}}/>
                        {!isMobile && <span className={"teamKey"}>{game.AwayTeamKey}</span>}
                    </div>
                </div>
            </div>
        </button>}
        {vm.filters.position && !isFilterBarOpen && <button className="positionFilter gold-gradient-border playerPosition"
                                                            onClick={() => handlePositionClick(vm.filters.position)}>
                {vm.filters.position}
            </button>}
    </div>;
}

export default FilterToggleBar;